import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
        '& .title': {
            color: '#005E96',
            fontSize: '16px',
        },
        '& .crtTitle': {
            color: '#005E96',
            fontSize: '16px',
            fontWeight: 'bold',
        },
    },
    '& .wapper': {
        width: '100%',
        padding: '20px',
        backgroundColor: '#fff',
        '& .upload-wapper': {
            width: "100%",
            height: '400px',
            backgroundColor: '#fff',
            border: '1px dashed #1A9AE7',
            '& .file-list': {
                width: '100%',
            },
            '& .toolbar': {
                width: "100%",
                height: "76px",
                padding: "0 20px",
                boxShadow: "0px -2px 5px 0px rgba(234, 234, 234, 0.5)",
            },
            '& .img': {
                color: '#1A9AE7',
                marginRight: '5px',
            },
            '& .del-btn': {
                color: 'red',
                cursor: 'pointer',
                marginRight: '10px',
            },
            '& .down-btn': {
                color: '#1A9AE7',
                cursor: 'pointer',
            },
        },
    },
    '& .table': {
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid #D8D8D8',
        '& th': {
            height: '70px',
            backgroundColor: '#F4F4F4',
        },
        '& td': {
            height: '70px',
            borderBottom: '1px solid #F4F4F4'
        },
    },
    '& .upload-title': {
        fontSize: '20px',
        fontWeight: 'bold',
        marginBottom: '20px'
    },
    '& .upload-subtitle': {
        fontSize: '18px',
        marginBottom: '20px'
    },
    '& .mr-10': {
        marginRight: '10px',
    },
});